import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import '../src/assets/scss/app.scss';
import { Provider } from 'react-redux';
import { store } from './store/index.ts';
import AppProvider from './providers/app.tsx';
import { initializeApplicationInsights } from './lib/applicationInsights.ts';
import { logger } from './lib/logger.ts';

// Start telemetry before the app mounts so early errors are captured.
initializeApplicationInsights();

// Catch errors React's ErrorBoundary can't see (async / non-render code).
window.addEventListener('unhandledrejection', (e) => {
  logger.error(e.reason, { source: 'unhandledrejection' });
});
window.addEventListener('error', (e) => {
  logger.error(e.error ?? e.message, { source: 'window.error' });
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </AppProvider>
  </StrictMode>,
);
